import type { Props as ShareButtonProps } from '@atlassian/jira-share-button/src/common/types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, createContainer } from '@atlassian/react-sweet-state';

// ProjectShareButtonProps is a subset of ShareButtonProps
// we don't support customizing the global share button from within the page
// so we don't need to support all the props that ShareButton supports
type NonVisualShareButtonProps = Omit<
	ShareButtonProps,
	| 'triggerButtonAppearance'
	| 'triggerButtonStyle'
	| 'renderCustomTriggerButton'
	| 'legacyShareClientConfig'
	| 'testId'
	| 'isAutoOpenDialog'
	| 'integrationMode'
	| 'shareShortcutTriggerCount'
	| 'prevShareShortcutTriggerCount'
>;

// make subProductId optional
type ProjectShareButtonProps = Partial<Pick<NonVisualShareButtonProps, 'subProductId'>> &
	Omit<NonVisualShareButtonProps, 'subProductId'>;

export const ProjectShareContainer = createContainer();

const initialState: ProjectShareButtonProps = {
	integrationType: '',
	productId: 'jira',
	subProductId: undefined,
	shareLink: undefined,
	shareTitle: '',
	shareContentType: '',
	shareFormTitle: undefined,
	objectAri: '',
	shareIntegrations: undefined,
	copyTooltipText: undefined,
	onDialogClose: undefined,
	onTriggerButtonClick: undefined,
	shareFormHelperMessage: undefined,
	shareFieldsFooter: undefined,
	poSpotlightShareButtonId: undefined,
};

const Store = createStore({
	containedBy: ProjectShareContainer,
	initialState,
	actions: {
		setContext:
			(context) =>
			({ setState }) => {
				setState({
					...initialState,
					...context,
				});
			},
		clearContext:
			() =>
			({ setState }) => {
				setState(initialState);
			},
	},
	name: 'project-share-button',
});

export const useProjectShareButton = createHook(Store);
